/* eslint-disable max-len */
import React from 'react';
import { Button } from 'reactstrap';
import Modal from '../../ui/Modal';
import { cfPath } from '../../utilities/UrlPaths';

const UpdateNotificationModal = ({
  isOpen,
  closeUpdateModal,
}) => {
  const closeAndReset = () => {
    closeUpdateModal(false);
  };

  const handleOnSubmit = () => {

    sessionStorage.clear();

    // Clear Service Worker Cache if Available
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }

    // Unregister Service Worker (if applicable)
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
    }

    fetch(window.location.href, {
      headers: {
        Pragma: 'no-cache',
        Expires: -1,
        'Cache-Control': 'no-cache'
      }
    }).then(() => {
      window.location.href = `${cfPath()}/login/logout.cfm`;
    });
  };

  return (
    <Modal isOpen={isOpen} className="modal-550" toggle={closeAndReset}>
      <Modal.Header toggle={closeAndReset}>
        <span className="no-caps">
          A new version of the application is available! Please log out and log back in to get the latest updates.
        </span>
      </Modal.Header>
      <Modal.Body />
      <Modal.Footer>
        <Button type="button" color="link" onClick={closeAndReset}>
          Cancel
        </Button>
        <Button type="submit" color="primary" onClick={() => handleOnSubmit()}>
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdateNotificationModal;
